/**
 * IMA SDK script loader stub — does not inject the SDK unless explicitly allowed.
 */

import { IMA_SDK_DEFAULT_URL } from "./modernVideoAdsFlags";

var loadPromise = null;

/**
 * @param {object} [options]
 * @param {boolean} [options.allowed] must be true to load
 * @param {string} [options.url]
 * @returns {Promise<{ google: object|null, loaded: boolean, reason: string }>}
 */
export function loadImaSdk(options) {
  options = options || {};
  if (!options.allowed) {
    return Promise.resolve({
      google: null,
      loaded: false,
      reason: "ima_sdk_load_not_allowed",
    });
  }

  if (typeof window === "undefined") {
    return Promise.resolve({
      google: null,
      loaded: false,
      reason: "no_window",
    });
  }

  if (window.google && window.google.ima) {
    return Promise.resolve({
      google: window.google,
      loaded: true,
      reason: "already_present",
    });
  }

  if (loadPromise) {
    return loadPromise;
  }

  var url = options.url || IMA_SDK_DEFAULT_URL;
  loadPromise = new Promise(function (resolve) {
    var existing = document.querySelector(
      'script[data-tpg-ima-sdk="1"]'
    );
    if (existing) {
      existing.addEventListener("load", function () {
        resolve({
          google: window.google || null,
          loaded: !!(window.google && window.google.ima),
          reason: "existing_script",
        });
      });
      return;
    }

    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.setAttribute("data-tpg-ima-sdk", "1");
    script.onload = function () {
      resolve({
        google: window.google || null,
        loaded: !!(window.google && window.google.ima),
        reason: "loaded",
      });
    };
    script.onerror = function () {
      loadPromise = null;
      resolve({
        google: null,
        loaded: false,
        reason: "load_error",
      });
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}

/**
 * Test helper — clear memoized loader state.
 */
export function resetImaSdkLoaderForTests() {
  loadPromise = null;
}

export default loadImaSdk;
